module.exports = __webpack_public_path__ + "assets/fa37b3f2d50765471c445d44973c9f7d.png";